
import { Component, ChangeDetectionStrategy, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-upgrade-banner',
  standalone: true,
  template: `
<div class="relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-600 to-blue-700 p-5 text-white shadow-elevated md:p-6 my-6">
  <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_90%_10%,rgba(255,255,255,.1),transparent_50%)]" aria-hidden="true"></div>
  <div class="relative flex flex-col lg:flex-row items-center justify-between gap-5">
    <div class="flex-grow text-center lg:text-left">
      <h3 class="text-lg font-bold tracking-tight">Desbloqueie sua Análise Completa</h3>
      <p class="text-indigo-100 mt-1 text-sm">Faça o upgrade para o plano Pro e receba a correção em 5 camadas, com:</p>
      <div class="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-3 text-left">
        <div class="flex items-center gap-2">
          <svg class="w-4 h-4 text-indigo-200 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.06 0l4-5.5Z" clip-rule="evenodd" /></svg>
          <span class="text-xs font-medium">Diagnóstico Cognitivo</span>
        </div>
         <div class="flex items-center gap-2">
          <svg class="w-4 h-4 text-indigo-200 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.06 0l4-5.5Z" clip-rule="evenodd" /></svg>
          <span class="text-xs font-medium">Reescrita Completa</span>
        </div>
         <div class="flex items-center gap-2">
          <svg class="w-4 h-4 text-indigo-200 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.06 0l4-5.5Z" clip-rule="evenodd" /></svg>
          <span class="text-xs font-medium">Plano de Evolução IA</span>
        </div>
      </div>
    </div>
    <button (click)="onUpgradeClick()" class="flex-shrink-0 rounded-xl bg-white px-6 py-2.5 text-sm font-bold text-indigo-600 shadow-md transition hover:bg-indigo-50 w-full sm:w-auto">
      Ver Planos Pro
    </button>
  </div>
</div>
`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class UpgradeBannerComponent {
  upgrade = output<void>();

  onUpgradeClick() {
    this.upgrade.emit();
  }
}
